import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { AdminDraftsProvider } from "@contexts/admin/AdminDraftsProvider";
import { AdminSessionProvider } from "@contexts/admin/AdminSessionProvider";

import AdminHome from "./AdminHome";
import { adminRoutePaths } from "./adminRoutes";
import { AdminShell } from "./AdminShell";
import { ComingSoon } from "./ComingSoon";
import RedoScreen from "./RedoScreen";
import ShipScreen from "./ShipScreen";
import AdminThemeProvider from "./theme/AdminThemeProvider";
import UiKitGallery from "./UiKitGallery";

// Screens the shell links to before they are built (SHELL-R11).
const comingSoonScreens = [
  { name: "Home", path: adminRoutePaths.insightsHome },
  { name: "Pharmacy routing", path: adminRoutePaths.pharmacyRouting },
];

// The rebuilt admin: its own providers and its own router, mounted by the
// entry gate once the admin is confirmed.
// Nothing here renders inside the patient Dashboard (XCUT-R4). Screens read
// the session through `useAdminSession` and API data through Redux selectors;
// nothing is threaded down as props (docs/architecture/admin-module.md).
const AdminApp = () => {
  const isGallery = useRouteMatch({ path: adminRoutePaths.uiKit, exact: true }) !== null;

  return (
    <AdminThemeProvider>
      <AdminSessionProvider>
        <AdminDraftsProvider>
          <AdminShell padding={isGallery ? "none" : "screen"}>
            <Switch>
              <Route exact path={adminRoutePaths.home} component={AdminHome} />
              <Route exact path={adminRoutePaths.uiKit} component={UiKitGallery} />
              <Route exact path={adminRoutePaths.ship} component={ShipScreen} />
              <Route exact path={adminRoutePaths.redo} component={RedoScreen} />
              {comingSoonScreens.map(({ name, path }) => (
                <Route key={path} exact path={path} render={() => <ComingSoon name={name} />} />
              ))}
              <Redirect to={adminRoutePaths.home} />
            </Switch>
          </AdminShell>
        </AdminDraftsProvider>
      </AdminSessionProvider>
    </AdminThemeProvider>
  );
};

export default AdminApp;
